import { render, staticRenderFns } from "./HomeSlogan.vue?vue&type=template&id=1b088d12&scoped=true&"
import script from "./HomeSlogan.vue?vue&type=script&lang=js&"
export * from "./HomeSlogan.vue?vue&type=script&lang=js&"
import style0 from "./HomeSlogan.vue?vue&type=style&index=0&id=1b088d12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b088d12",
  null
  
)

export default component.exports